<template>
    <div>
        <link-header
            v-bind:header-data="headerDetails"
            v-bind:use-internal-routes="true"
            @segmentationselected="changeBookingSystem"
            @languageselected="changeLanguage"
            v-if="isUserLoaded"
        ></link-header>
        <postalCodeModal />
    </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import { EventBus } from '../services/event-bus.js';
  import i18n from '../i18n';
  import dkFlag from '../assets/DK.png';
  import noFlag from '../assets/NO.png';
  import usFlag from '../assets/US.png';
  import { ACTIONS, MUTATIONS, CREATE_SHIPMENT_PREFIX, CORE_PREFIX } from '../store/constants';
  import { allBookingSystems, allLanguages } from '../data/headerData.js';
  import postalCodeModal from '../components/postal-code';
  import viewOptions from '../mixins/viewOptionsMixin';
  import { authService } from '../msal';
  import LinkHeader from "@/components/Header/LinkHeader.vue";

  export default {
      components: {LinkHeader, postalCodeModal },
      data() {
          return {
              selectedBookingSystem: '',
              collapsed: true,
              username: '',
              segmentationDetails: {},
              renderTrigger: new Date(),
              eventsInitialized: false,
              manifestModalApplied: false,
            postalCodeModalApplied: false,
            resetShipmentComponentEventApplied: false,
            downloadDocumentPackageApplied: false,
            testUserEventApplied: false,
            menuEventApplyList:[]
          };
      },
      updated: function () {
              this.$nextTick(function () {
                  this.applyManifestModal(this);
                  this.applyPostalCodeModal(this);
                  this.addResetShipmentComponentEvent();
                  this.applyDownloadDocumentPackage(this, 'tools.tntDocumentPack', 'TNT');
                  this.applyDownloadDocumentPackage(this, 'tools.glsDocumentPack', 'GLS');
                  this.addTestUserEvent(this);
                  
              });
      },
      watch: {
          headerDetails(headerData) {
            this.menuItemShouldOpenInNewTab(headerData)
          },
      },

      mounted() {
          this.$emit('initialized');
      },

      computed: {
          ...mapGetters('core', [
              'isCustomer',
              'isTestMode',
              'isAdminOrSuperUser',
              'getUserData',
              'getHeaderData',
          ]),

          profile() {
              return this.$auth.profile;
          },
          async isUserLoaded() {
              return await authService.getAuthUser() !== undefined;
          },
          headerDetails() {
              if (
                  this.getUserData.assignedRoles !== undefined &&
                  this.isUserLoaded &&
                  this.selectedBookingSystem != null &&
                  this.renderTrigger
              ) {
                  const userRoles = []; //TODO
                  const appSwitcherMenu = this.applyAppSwitcherItems(userRoles);

                  const languageCookie = $cookies.get('language');
                  const mainMenuItems = this.applyMainMenuItems();
                  
                  const segmentationDetails = this.applySegmentationDetails();
                  let segmentation = $cookies.get('segmentation');
                  if (segmentation !== "YOYODenmark" && segmentation !== "YOYOSweden"){
                    //Remove element from mainMenuItems with Keys (fuel.main,user-guide.main) if segmentation is not YOYODenmark
                    mainMenuItems.splice(mainMenuItems.findIndex(e => e.Key === 'fuel.main'), 1);
                    mainMenuItems.splice(mainMenuItems.findIndex(e => e.Key === 'user-guide.main'), 1);
                    mainMenuItems.splice(mainMenuItems.findIndex(e => e.Key === 'pickup.main'), 1);
                  }
                  var locale = i18n.locale;

                  const result = {
                      User: {
                          Name: this.isTestMode
                              ? authService.getUser().name + ' (Test Mode)'
                              : authService.getUser().name,
                          ShortName: authService.getUser().name,
                      },
                      ShowEnvironmentWarnining: process.env.NODE_ENV === 'production' ? false : true,
                      Search: null,
                      LogoUrl: null,
                      hideLogo: false,
                      EnvironmentHeader: this.getHeaderData.environmentName,
                      MainMenu: mainMenuItems,
                      SegmentationDetails: segmentationDetails,

                      UserMenu: [
                          {
                              Name: i18n.t('menu.core.logout'),
                              IconName: null,
                              Link: '/Logout',
                              ToolTip: null,
                              IsDivider: false,
                              IsActive: false,
                          },
                          {
                              Name: i18n.t('menu.core.helpabout'),
                              IconName: null,
                              Link: '/About',
                              ToolTip: null,
                              IsDivider: false,
                              IsActive: false,
                          },
                      ],

                      AppSwitcherMenu: appSwitcherMenu,
                  };
                  if (this.isAdminOrSuperUser && screen.width < 1600) {
                      result.hideLogo = true;
                  }

                  this.applyTestUserMenuIfApplicable(result);

                  this.applyHangfireIfApplicable(result);

                  return result;
              }
              return null;
          },
      },
      methods: {
          applyTestUserMenuIfApplicable(result) {
              if (this.isAdminOrSuperUser) {
                  result.UserMenu.push({
                      Name: i18n.t('menu.core.testUser'),
                      IconName: null,
                      Link: null,
                      IsDivider: false,
                      IsActive: false,
                  });
              }
          },

          applyCustomerMenu() {
              const mainMenuItems = [
                  {
                      Name: i18n.t('menu.shipment.create'),
                      IconName: null,
                      Link: '/Createbooking',
                      Key: 'menu.createShipment',
                      ToolTip: null,
                      IsDivider: false,
                      IsActive: false,
                  },{
                  Name: "Create Pickup",
                  IconName: null,
                  Link: "/Pickup",
                  Key: "pickup.main",
                  ToolTip: null,
                  IsDivider: false,
                  IsActive: false
                },
                  {
                      Name: i18n.t('menu.shipment.history'),
                      IconName: null,
                      Link: '/History',
                      Key: 'menu.history',
                      ToolTip: null,
                      IsDivider: false,
                      IsActive: false,
                  },
                  {
                      Name: i18n.t('menu.tools.manifest'),
                      Key: 'menu.manifest',
                      IconName: null,
                      Link: '#manifest',
                      ToolTip: null,
                      IsDivider: false,
                      IsActive: false,
                  },
                  {
                      Name: i18n.t('menu.tools.postalcode'),
                      IconName: null,
                      Link: '#postalcode',
                      Key: 'menu.postalcode',
                      ToolTip: null,
                      IsDivider: false,
                      IsActive: false,
                  },
                {
                  Name: "Fuel Rates",
                  IconName: null,
                  Link: "https://my.linklog.com/fuel/",
                  Key: "fuel.main",
                  ToolTip: null,
                  IsDivider: false,
                  IsActive: false,
                  OpenInNewTab: true
                },
                {
                  Name: "User Guide",
                  IconName: null,
                  Link: "https://linklog.com/en/mylink-guide/",
                  Key: "user-guide.main",
                  ToolTip: null,
                  IsDivider: false,
                  IsActive: false,
                  OpenInNewTab: true
                }
              ];
              
              let headerData = this.getHeaderData;
              if (headerData.showShotFileLink){
                mainMenuItems.push({
                  Name: i18n.t('menu.shipment.shotFile'),
                  IconName: null,
                  Link: '/ShotFile',
                  Key: 'menu.shotFile',
                  ToolTip: null,
                  IsDivider: false,
                  IsActive: false,
                });
              }

              return mainMenuItems;
          },
          applyEmployeeMenu() {
              const mainMenuItems = [
                  {
                      Name: i18n.t('menu.shipment.create'),
                      IconName: null,
                      Link: '/Createbooking',
                      Key: 'menu.createShipment',
                      ToolTip: null,
                      IsDivider: false,
                      IsActive: false,
                  },{
                  Name: "Create Pickup",
                  IconName: null,
                  Link: "/Pickup",
                  Key: "pickup.main",
                  ToolTip: null,
                  IsDivider: false,
                  IsActive: false
                  }
              ];

              this.applyLegacyMainMenuItems(mainMenuItems);

              mainMenuItems.push({
                  Name: i18n.t('menu.shipment.history'),
                  IconName: null,
                  Link: '/History',
                  Key: 'menu.history',
                  ToolTip: null,
                  IsDivider: false,
                  IsActive: false,
              });
            mainMenuItems.push({
              Name: i18n.t('menu.shipment.shotFile'),
              IconName: null,
              Link: '/ShotFile',
              Key: 'menu.shotFile',
              ToolTip: null,
              IsDivider: false,
              IsActive: false,
            });

            mainMenuItems.push({
                Name: "Fuel Rates",
                IconName: null,
                Link: "https://my.linklog.com/fuel/",
                Key: "fuel.main",
                ToolTip: null,
                IsDivider: false,
                IsActive: false,
                OpenInNewTab: true
              });
            mainMenuItems.push({
              Name: "User Guide",
              IconName: null,
              Link: "https://linklog.com/en/mylink-guide/",
              Key: "user-guide.main",
              ToolTip: null,
              IsDivider: false,
              IsActive: false,
              OpenInNewTab: true
            });
                

              return mainMenuItems;
          },

          makeToast(variant = null, title, body) {
              this.$bvToast.toast(body, {
                  title: title,
                  variant: variant,
                  solid: true,
              });
          },
        
        
          menuItemShouldOpenInNewTab(headerData) {
            headerData.MainMenu.forEach((menuItem) => {
              if (menuItem.OpenInNewTab) {
                let elem = document.getElementById(menuItem.Key);
                if (elem !== null) {
                  elem.setAttribute("target", "_blank");
                } else {
                }
              }
            });
          },
          addTestUserEvent(self) {
              if (this.isAdminOrSuperUser) {
                  if(this.testUserEventApplied)
                    return;
                
                  var element = document.getElementById('menu:Test User');

                  if (element !== null) {
                      element.addEventListener('click', function () {

                          self.$store.dispatch(
                              CORE_PREFIX + ACTIONS.CORE.SET_TEST_USER,
                              !self.isTestMode
                          );
                      });
                      this.testUserEventApplied = true;
                  }
              }
          },
          addResetShipmentComponentEvent() {
              if(this.resetShipmentComponentEventApplied)
                return;
            
              var element = document.getElementById('menu.createShipment');

              if (element !== null) {
                  element.addEventListener('click', function () {
                      EventBus.$emit('resetShipmentEvent');
                  });
                  this.resetShipmentComponentEventApplied = true;
              }
          },
          applyDownloadDocumentPackage(self, elementId, carrier) {
              if(this.menuEventApplyList.includes(elementId))
                return;
            
              var element = document.getElementById(elementId);

              if (element !== null) {
                  element.href = '#';

                  element.addEventListener('click', function () {
                      self.$emit('documentPackModalOpened', carrier);
                  });
                  this.menuEventApplyList.push(elementId);
              }
          },

          applyManifestModal(self) {
            if(this.manifestModalApplied)
              return;
            
              var element = document.getElementById('menu.manifest');
              if (element !== null) {
                  element.href = '#';

                  element.addEventListener('click', function () {
                      self.$emit('dailyManifestModalOpened', true);
                  });
                this.manifestModalApplied = true;
              }
          },
          applyPostalCodeModal(self) {
            if(this.postalCodeModalApplied)
              return;
            
              var element = document.getElementById('menu.postalcode');
              if (element == null) {
                  element = document.getElementById('tools.postalcode');
              }
              if (element !== null) {
                  element.href = '#';
                  element.addEventListener('click', function () {
                      self.$bvModal.show('_postal-code-modal');
                  });
                  this.postalCodeModalApplied = true;
              } else {
                  console.error('Postalcode MenuItem not found');
              }
          },
          applySegmentationDetails() {
              const segmentations = this.applySegmentations();
              this.ensureSegmentationCookies(segmentations);

              const languageCookie = $cookies.get('language');
              i18n.locale = languageCookie;

              const selectedSegmentation = this.selectedSegmentationData(segmentations);

              const result = {
                  SegmentationHeader: i18n.t('createShipment.header.SelectedBookingSystemLabel'),
                  SegmentationFlagUrl: selectedSegmentation.flagUrl,
                  SelectedSegmentationKey: selectedSegmentation.bookingSystemKey,
                  SelectedLanguageKey: languageCookie,
                  SelectedLanguageTitle: i18n.t('createShipment.header.LanguageLabel'),
                  AvailableLanguages: allLanguages,
                  AvailableSegmentations: segmentations,
              };

              return result;
          },
          selectedSegmentationData(segmentations) {
              const segmentationCookie = $cookies.get('segmentation');
              let flagUrl = dkFlag;
              let bookingSystemKey = '';

              if (segmentations.length > 0) {
                  const selectedSegmentation = segmentations.find((obj) => {
                      return obj.SegmentationSystemKey === segmentationCookie;
                  });

                  if (selectedSegmentation !== undefined) {
                      flagUrl = selectedSegmentation.FlagUrl;
                      bookingSystemKey = selectedSegmentation.SegmentationSystemKey;
                  }
              }
              return { flagUrl, bookingSystemKey };
          },
          ensureSegmentationCookies(segmentations) {
              let languageCookie = $cookies.get('language');
              let segmentationCookie = $cookies.get('segmentation');
              if (segmentations.length > 0 && segmentationCookie == null) {
                  this.$cookies.set('segmentation', segmentations[0].SegmentationSystemKey);
              }

              if (languageCookie == null) {
                  this.$cookies.set('language', 'en');
                  languageCookie = $cookies.get('language');
              }
          },
          applySegmentations() {
              const segmentations = [];

              if (this.getHeaderData.segmentationDetails !== undefined) {
                  allBookingSystems.forEach((element) => {
                      const userExists = this.getHeaderData.segmentationDetails.segmentations.find(
                          (obj) => {
                              return obj.shipmentSystem === element.bookingSystemKey;
                          }
                      );
                      const i18nParams = {
                          segmentation: element.bookingSystemKey.replace("YOYO",""),
                      };

                      if (userExists) {
                          segmentations.push({
                              Name: element.name,
                              FlagUrl: element.flagUrl,
                              DescriptionNotSelected: i18n.t(
                                  'createShipment.header.DescriptionNotSelected',
                                  i18nParams
                              ),
                              DescriptionSelected: i18n.t(
                                  'createShipment.header.DescriptionSelected',
                                  i18nParams
                              ),
                              SegmentationSystemKey: element.bookingSystemKey,
                          });
                      }
                  });
              }
              return segmentations;
          },
          applyMainMenuItems() {
              if (this.isCustomer) {
                  return this.applyCustomerMenu();
              }

              if (this.isAdminOrSuperUser) {
                  return this.applyEmployeeMenu();
              }
          },
          applyLegacyMainMenuItems(mainMenuItems) {
              this.getHeaderData.menuItems.forEach((menuItem) => {
                  const subitems = [];

                  if (menuItem.subItems.length > 0) {
                      menuItem.subItems.forEach((subItem) => {
                          subitems.push({
                              Name: i18n.t('menu.' + subItem.key), //subItem.name,
                              Link: subItem.link,
                              Key: subItem.key,
                          });
                      });

                      this.applyTNTDocumentPack(menuItem, subitems);
                      this.applyGLSDocumentPack(menuItem, subitems);
                    this.applyPickupModule(menuItem,subitems);
                  }

                  mainMenuItems.push({
                      Name: i18n.t('menu.' + menuItem.key), //menuItem.name,
                      IconName: null,
                      Link: menuItem.link,
                      ToolTip: null,
                      IsDivider: false,
                      IsActive: false,
                      SubItems: subitems.length === 0 ? undefined : subitems,
                  });
              });
          },

          applyTNTDocumentPack(menuItem, subitems) {
              if (this.isAdminOrSuperUser) {
                  if (menuItem.key === 'tools.main') {
                      subitems.push({
                        Name: i18n.t('menu.tools.tntDocumentPack'),
                        Link: '#',
                        Key: 'tools.tntDocumentPack',
                      });
                  }
              }
          },
        applyPickupModule(menuItem, subitems) {
          if (this.isAdminOrSuperUser) {
            if (menuItem.key === 'tools.main') {
              subitems.push({
                Name: "Pickup Module",
                Link: 'https://pickup.yoyoglobal.com',
                Key: 'tools.pickupModule',
              });
            }
          }
        },
        applyGLSDocumentPack(menuItem, subitems) {
          if (this.isAdminOrSuperUser) {
            if (menuItem.key === 'tools.main') {
              subitems.push({
                Name: i18n.t('menu.tools.glsDocumentPack'),
                Link: '#gls',
                Key: 'tools.glsDocumentPack',
              });
            }
          }
        },

          applyAppSwitcherItems(userRoles) {
              const appSwitcherMenu = [];

              this.getHeaderData.appSwitcherItems.forEach((ai) => {
                  let inRole = false;

                  if (userRoles != null) {
                      userRoles.forEach((ur) => {
                          ai.requiredRole.forEach((rr) => {
                              if (rr === ur) {
                                  inRole = true;
                              }
                          });
                      });
                  }

                  if (inRole || ai.requiredRole.length == 0) {
                      appSwitcherMenu.push({
                          Name: ai.name,
                          Link: ai.link,
                          IconName: ai.icon,
                      });
                  }
              });
              return appSwitcherMenu;
          },

          applyHangfireIfApplicable(result) {
              var headerData = this.getHeaderData;

              if (headerData.showHangfireLink) {
                  result.UserMenu.push({
                      Name: '',
                      IconName: null,
                      Link: '/d',
                      ToolTip: null,
                      IsDivider: true,
                      IsActive: false,
                  });

                  result.UserMenu.push({
                      Name: 'Hangfire',
                      IconName: null,
                      Link: '/hangfire',
                      ToolTip: null,
                      IsDivider: false,
                      IsActive: false,
                  });
              }
          },

          changeBookingSystem(input) {
              this.selectedBookingSystem = input;
              this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.CHANGE_BOOKINGSYSTEM, input);
              this.$cookies.set('segmentation', input);
          },

          changeLanguage(languageKey) {
              i18n.locale = languageKey;
              this.$cookies.set('language', languageKey);
          },
      },
  };
</script>

<style>
  .slide-enter-active,
  .slide-leave-active {
      transition: max-height 0.35s;
  }
  .slide-enter,
  .slide-leave-to {
      max-height: 0px;
  }

  .slide-enter-to,
  .slide-leave {
      max-height: 20em;
  }

  .navbar {
      font-size: 14px !important;
      color: #1f7037;
      font-weight: 400;
  }

  .navbar ul li a {
      font-size: 14px;
      padding-left: 15px !important;
      padding-right: 15px !important;
  }
</style>
